import pako from "pako";
import base64 from "base64-js";
import { Buffer } from "buffer";

const decompressData = (data) => {
  return pako.ungzip(data, { to: "string" });
};

// Function to decode base64 to buffer
function decodeBase64(base64String) {
  return Buffer.from(base64.toByteArray(base64String));
}

// Function to decompress base64-encoded compressed JSON string
const decompressJsonObject = (base64Compressed) => {
  // Decode the base64 string to buffer
  if (base64Compressed && typeof base64Compressed === "string") {
    const compressedBuffer = decodeBase64(base64Compressed);
    // Decompress the buffer
    const decompressedBuffer = decompressData(compressedBuffer);
    // Parse decompressedBuffer to object
    const jsonObject = JSON.parse(decompressedBuffer);
    return jsonObject;
  }
  return base64Compressed;
};

export default decompressJsonObject;
